// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/pen-line.js';

import { paths } from '../generated/pen-line';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('pen-line', Original, paths);
